import { mutatorAction } from 'satcheljs';
import type RibbonViewState from '../store/schema/RibbonViewState';
import type RibbonButton from '../components/buttons/RibbonButton';

export const RIBBON_ITEM_WIDTH = 38;

const setButtonWidths = mutatorAction(
    'Ribbon_SetButtonWidths',
    (viewState: RibbonViewState, buttons: RibbonButton[]) => {
        viewState.buttonWidths = buttons.map(button => button.width || RIBBON_ITEM_WIDTH);
    }
);

export default setButtonWidths;
